export const locales = {
  ru: require("./ru.json"),
  et: require("./et.json"),
  en: require("./en.json"),
};
